/**
 * Shared AG Grid colId → API sort mappings for pharmacy / retail reports.
 * Search uses the same table.column pairs via searchFieldMapFromSortMap().
 */

export const PHARMACY_REPORT_SORT_MAP = {
  firstname: { tableName: 'customers', sortColumn: 'first_name' },
  lastname: { tableName: 'customers', sortColumn: 'last_name' },
  first_name: { tableName: 'customers', sortColumn: 'first_name' },
  last_name: { tableName: 'customers', sortColumn: 'last_name' },
  patientNotes: { tableName: 'customers', sortColumn: 'notes' },
  store: { tableName: 'accounts', sortColumn: 'name' },
  store_name: { tableName: 'accounts', sortColumn: 'name' },
  box: { tableName: 'boxes', sortColumn: 'name' },
  box_name: { tableName: 'boxes', sortColumn: 'name' },
  deliverytype: { tableName: 'locationtype_master', sortColumn: 'name' },
  binid: { tableName: 'prescriptions_master', sortColumn: 'bin_id' },
  bin_id: { tableName: 'prescriptions_master', sortColumn: 'bin_id' },
  rxno: { tableName: 'prescription_detail', sortColumn: 'rx_no' },
  rx_no: { tableName: 'prescription_detail', sortColumn: 'rx_no' },
  fillid: { tableName: 'prescription_detail', sortColumn: 'fillnumber' },
  prescriptionnumber: { tableName: 'prescription_detail', sortColumn: 'prescriptionnumber' },
  OrderId: { tableName: 'prescription_detail', sortColumn: 'order_id' },
  order_id: { tableName: 'prescription_detail', sortColumn: 'order_id' },
  PrescriptionTxnId: { tableName: 'prescription_detail', sortColumn: 'prescription_txn_id' },
  prescription_txn_id: { tableName: 'prescription_detail', sortColumn: 'prescription_txn_id' },
  ndccode: { tableName: 'prescription_detail', sortColumn: 'ndc_code' },
  drugname: { tableName: 'prescription_detail', sortColumn: 'drug_name' },
  stock_code: { tableName: 'prescriptions_master', sortColumn: 'stock_code' },
  pucode: { tableName: 'prescriptions_master', sortColumn: 'pucode' },
  qty: { tableName: 'prescription_detail', sortColumn: 'qty' },
  price: { tableName: 'prescription_detail', sortColumn: 'price' },
  createdon: { tableName: 'prescriptions_master', sortColumn: 'created_on' },
  created_on: { tableName: 'prescriptions_master', sortColumn: 'created_on' },
  transactiondate: { tableName: 'events', sortColumn: 'created_on' },
  stockeddate: { tableName: 'prescriptions_master', sortColumn: 'stocked_date' },
  stocked_date: { tableName: 'prescriptions_master', sortColumn: 'stocked_date' },
  filldate: { tableName: 'prescriptions_master', sortColumn: 'fill_date' },
  pickupdate: { tableName: 'prescriptions_master', sortColumn: 'pickup_date' },
  pickup_date: { tableName: 'prescriptions_master', sortColumn: 'pickup_date' },
  is_consultrequire: { tableName: 'prescription_detail', sortColumn: 'is_consultrequire' },
  username: { tableName: 'users', sortColumn: 'name' },
  user_name: { tableName: 'users', sortColumn: 'name' },
};

/** Audit Trail Date/Time is audit_report.created_on, not prescriptions_master. */
export const AUDIT_REPORT_SORT_MAP = {
  first_name: { tableName: 'users', sortColumn: 'first_name' },
  last_name: { tableName: 'users', sortColumn: 'last_name' },
  store_name: { tableName: 'accounts', sortColumn: 'name' },
  location_name: { tableName: 'boxes', sortColumn: 'name' },
  action_name: { tableName: 'audit_report', sortColumn: 'action_name' },
  description: { tableName: 'audit_report', sortColumn: 'description' },
  username: { tableName: 'users', sortColumn: 'name' },
  created_on: { tableName: 'audit_report', sortColumn: 'created_on' },
};

export const PATIENT_LIST_SORT_MAP = {
  first_name: { tableName: 'customers', sortColumn: 'first_name' },
  last_name: { tableName: 'customers', sortColumn: 'last_name' },
  member_id: { tableName: 'customers', sortColumn: 'member_id' },
  drivers_license_no: { tableName: 'customers', sortColumn: 'drivers_license_no' },
  dob: { tableName: 'customers', sortColumn: 'dob_str' },
  dob_str: { tableName: 'customers', sortColumn: 'dob_str' },
  email: { tableName: 'contacts', sortColumn: 'email' },
  phone: { tableName: 'contacts', sortColumn: 'phone' },
  name: { tableName: 'customer_type', sortColumn: 'name' },
  source: { tableName: 'customer_type', sortColumn: 'name' },
  enroll_date: { tableName: 'customers', sortColumn: 'created_on' },
  created_on: { tableName: 'customers', sortColumn: 'created_on' },
};

export const RETAIL_REPORT_SORT_MAP = {
  profile_id: { tableName: 'icustomers_v2', sortColumn: 'profile_id' },
  email: { tableName: 'icustomers_v2', sortColumn: 'email' },
  first_name: { tableName: 'icustomers_v2', sortColumn: 'first_name' },
  last_name: { tableName: 'icustomers_v2', sortColumn: 'last_name' },
  mobile_no: { tableName: 'icustomers_v2', sortColumn: 'mobile_no' },
  invoice_id: { tableName: 'orders_details_v2', sortColumn: 'invoice_id' },
  job_id: { tableName: 'orders_details_v2', sortColumn: 'job_id' },
  item_name: { tableName: 'ecom_product_v2', sortColumn: 'name' },
  item_id: { tableName: 'ecom_product_v2', sortColumn: 'product_id' },
  bin_id: { tableName: 'orders_v2', sortColumn: 'bin_id' },
  stock_code: { tableName: 'orders_v2', sortColumn: 'stock_code' },
  pickup_code: { tableName: 'orders_v2', sortColumn: 'pickup_code' },
  request_no: { tableName: 'orders_v2', sortColumn: 'request_no' },
  store: { tableName: 'accounts', sortColumn: 'name' },
  box: { tableName: 'boxes', sortColumn: 'name' },
  created_on: { tableName: 'retail_events_v2', sortColumn: 'created_on' },
  stocked_date: { tableName: 'orders_v2', sortColumn: 'stocked_date' },
  pickuped_date: { tableName: 'orders_v2', sortColumn: 'pickuped_date' },
  removed_date: { tableName: 'orders_v2', sortColumn: 'removed_date' },
  transaction_date: { tableName: 'retail_events_v2', sortColumn: 'created_on' },
  username: { tableName: 'users', sortColumn: 'name' },
  user_name: { tableName: 'users', sortColumn: 'name' },
  operation: { tableName: 'retail_events_v2', sortColumn: 'operation' },
};

export const searchFieldMapFromSortMap = (sortMap = {}) => {
  const out = {};
  Object.keys(sortMap).forEach((colId) => {
    const mapping = sortMap[colId];
    if (mapping && mapping.tableName && mapping.sortColumn) {
      out[colId] = `${mapping.tableName}.${mapping.sortColumn}`;
    }
  });
  return out;
};



// WEBPACK FOOTER //
// ./src/components/grid/reportColumnMaps.js